export function localToday() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function monthKeyFromDate(value) {
  if (value == null || value === "") return "";
  const match = String(value).match(/^(\d{4}-\d{2})/);
  return match ? match[1] : "";
}

export function dateInputValue(value, fallback = "") {
  const match = String(value || "").match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : fallback;
}

export function defaultDateForMonth(month) {
  const today = localToday();
  if (!month || !/^\d{4}-\d{2}$/.test(month)) return today;
  if (today.slice(0, 7) === month) return today;
  return `${month}-01`;
}

export function money(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = parseFloat(value.replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
}

export function formatFrDate(value) {
  if (!value) return "N/A";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return `${match[3]}/${match[2]}/${match[1]}`;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "N/A";
  return date.toLocaleDateString("fr-FR");
}

export function formatMonthLabel(month) {
  const match = String(month || "").match(/^(\d{4})-(\d{2})$/);
  if (!match) return "";
  const date = new Date(Number(match[1]), Number(match[2]) - 1, 1);
  return date.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
}

function shiftMonth(month, delta) {
  const [year, mon] = month.split("-").map(Number);
  const date = new Date(year, mon - 1 + delta, 1);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

function sumForMonth(rows, driverId, dateField, amountField, month) {
  return (rows || []).reduce((sum, row) => {
    if (driverId && row.driver_id !== driverId) return sum;
    if (monthKeyFromDate(row[dateField]) !== month) return sum;
    return sum + money(row[amountField]);
  }, 0);
}

export function computeSalaryMonth({
  driverId,
  month,
  baseSalary,
  startDate,
  advances,
  payments,
  absences,
}) {
  const base = money(baseSalary);
  const target = monthKeyFromDate(month) || month;
  const empty = {
    carryIn: 0,
    remaining: base,
    totalAdvances: 0,
    totalPayments: 0,
    totalDeductions: 0,
  };
  if (!target || !/^\d{4}-\d{2}$/.test(target)) return empty;

  const monthKeys = [];
  const collect = (rows, field) => {
    for (const row of rows || []) {
      if (driverId && row.driver_id !== driverId) continue;
      const key = monthKeyFromDate(row[field]);
      if (key) monthKeys.push(key);
    }
  };
  collect(advances, "advance_date");
  collect(payments, "payment_date");
  collect(absences, "absence_date");
  const startKey = monthKeyFromDate(startDate);
  if (startKey) monthKeys.push(startKey);
  monthKeys.push(target);
  monthKeys.sort();

  let cursor = monthKeys[0];
  let carry = 0;
  let guard = 0;
  while (cursor <= target && guard < 600) {
    const totalAdvances = sumForMonth(advances, driverId, "advance_date", "amount", cursor);
    const totalPayments = sumForMonth(payments, driverId, "payment_date", "salary_paid", cursor);
    const totalDeductions = sumForMonth(absences, driverId, "absence_date", "deduction_amount", cursor);
    const remaining = base - totalPayments - totalAdvances - totalDeductions - carry;
    if (cursor === target) {
      return { carryIn: carry, remaining, totalAdvances, totalPayments, totalDeductions };
    }
    carry = remaining < 0 ? -remaining : 0;
    cursor = shiftMonth(cursor, 1);
    guard += 1;
  }

  return empty;
}
